import classNames from "classnames"

import { Color } from "../../../constants/V2/color"
import PillButton from "../../elements/V2/Buttons/PillButton"
import StickyContainer from "../../elements/V2/StickyContainer"
import { NavigationV2Context } from "../Navigation/context"

import AddToCartButton from "@components/elements/V2/Buttons/AddToCartButton"
import { usePageLayoutState } from "@utils/layout"
import React, { useContext } from "react"

type Props = {
  className?: string
  primaryButtonText?: string
  primaryButtonLink?: string | YocoCom.YocoLink
  primaryButtonMobileLink?: string | YocoCom.YocoLink
  primaryButtonColor?: Color
  isCtaVisible?: boolean
  children: React.ReactNode
  hideMobileButton?: boolean
} & Partial<Storyblok.CTATrackingEvent>

const HeroLayout = ({
  className,
  primaryButtonText,
  primaryButtonLink,
  primaryButtonMobileLink,
  primaryButtonColor = Color.Blue,
  hideMobileButton = false,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  children,
}: Props) => {
  const navigationContext = useContext(NavigationV2Context)

  const {
    heroCTAPurchasableItem,
    hasSiteBanner,
    hasAnchorNavigation: hasNavigationBar,
    heroCTAVisible,
  } = usePageLayoutState()

  const hasButton = !!(primaryButtonText && primaryButtonLink)

  return (
    <>
      <div
        className={classNames(
          "pb-lg -mb-lg -order-1 sm:-order-2",
          className,
          hasNavigationBar
            ? hasSiteBanner
              ? "sm:max-h-screen md:max-h-[90dvh] lg:max-h-[88dvh] xl:max-h-[91dvh]"
              : "sm:max-h-screen md:max-h-[95dvh] lg:max-h-[95dvh] xl:max-h-[95dvh]" //NO site banner
            : ""
        )}
      >
        {children}
      </div>

      <StickyContainer
        isVisible={
          hasButton &&
          typeof heroCTAVisible === "boolean" &&
          !heroCTAVisible &&
          !navigationContext.isMobileMenuOpen &&
          !hideMobileButton
        }
      >
        {heroCTAPurchasableItem ? (
          <AddToCartButton
            size="large"
            style="solid"
            purchasableItem={heroCTAPurchasableItem}
            buttonColor={primaryButtonColor}
          />
        ) : hasButton ? (
          <PillButton
            size="large"
            style="solid"
            text={primaryButtonText}
            color={primaryButtonColor}
            linkUrl={primaryButtonLink}
            mobileLinkUrl={primaryButtonMobileLink}
            trackingEvent={trackingEvent}
            trackingEventKey={trackingEventKey}
            trackingEventValue={trackingEventValue}
          />
        ) : null}
      </StickyContainer>
    </>
  )
}

export default HeroLayout
